'use strict';
import React, {Component} from 'react';
import * as T from 'prop-types';
import classNames from 'classnames';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import * as FlipMoveConfig from '../../../config/style/FlipMoveListConfig';
import {getId} from '../../../core-utilities/domain/ReduxUtils';
import {FilterInput} from '../../../components/lists/FilterInput';
import {ViewMode} from '../../../core-utilities/enums/ViewMode';
import {getItemClass} from '../../../core-utilities/redux/utils';
import {StatusOverlayComponent} from '../../../core-components/loading-icon/components/StatusOverlayComponent';
import {LoadMoreComponent} from '../../../core-components/loading-icon/components/LoadMoreComponent';
import {MeasuredChatView} from '../../../core-components/measured-chat-view/MeasuredChatView';
import {DateHeader} from '../../../components/lists/DateHeader';
import {SUB_HEADER} from '../../redux/peopleConfig';
import {PeopleItem} from '../PeopleItem';


export class PeopleSelectorListComponent extends Component {
  static propTypes = {
    className: T.string,
    useTypeHeaders: T.bool,
    useSimple: T.bool,
    useSelection: T.bool,
    selected: T.object,
    nullable: T.bool,
    nullLabel: T.string,
    filter: T.string,
    filterOptions: T.object,
    onClick: T.func,
    onClickNullItem: T.func,
    onClickItem: T.func,
    onItemContextMenu: T.func,
  };

  static defaultProps = {
    useTypeHeaders: true,
    useSimple: false,
    useSelection: false,
    nullLabel: 'personnel.select.null.label',
  };

  constructor(props) {
    super(props);

    this.renderItem = this.renderItem.bind(this);
  }

  render() {
    return (
      <div
        className={classNames("PeopleSelectorList", this.props.className)}
        onClick={this.props.onClick}
      >
        {this.renderHeader()}

        <StatusOverlayComponent mode={this.props.mode} />
        <div className="full-height-with-filter list-button-row no-padding-lr wide-view-constrained activity-feed-list">
          <MeasuredChatView
            className="activity-feed-scroll-panel requirement-breakdown"
            flipped={false}
            autoScroll={false}
            scrollLoadThreshold={50}
            onInfiniteLoad={this.props.onLoadMore}
            usePropLoading={true}
            loadingSpinnerDelegate={<LoadMoreComponent mode={this.props.mode} />}
            isInfiniteLoading={this.props.mode === ViewMode.LOADING_MORE}
          >
            <ReactCSSTransitionGroup
              transitionName={FlipMoveConfig.transitionName}
              transitionAppear={FlipMoveConfig.transitionAppear}
              transitionAppearTimeout={FlipMoveConfig.transitionAppearTimeout}
              transitionEnterTimeout={FlipMoveConfig.transitionEnterTimeout}
              transitionLeaveTimeout={FlipMoveConfig.transitionLeaveTimeout}
              className="list"
            >
              {this.renderNullItem()}
              {this.props.list ? this.props.list.map(this.renderItem) : null}
            </ReactCSSTransitionGroup>
          </MeasuredChatView>
        </div>
      </div>
    );
  }

  renderHeader() {
    // TODO: need to either make this more configurable or match the current list directive template
    return (
      <div className="padding-container-7 filter-input-outer-container task-details">
        <div />
        <div>
          <FilterInput
            className="filter-input-inner-container filter-input"
            lockedOpenDesktop={true}
            showFilterOptions={true}
            searchOnly={true}

            onFilterChange={this.props.onFilterChange}
            onChangeDebounce={450}
          />
        </div>
      </div>
    );
  }

  renderNullItem() {
    if (this.props.useSelection && this.props.nullable) {
      return (
        <PeopleItem
          key="null"
          isSimple={this.props.useSimple}
          isSelected={this.props.selected === null}
          nullLabel={this.props.nullLabel}
          model={null}
          onClick={this.props.onClickNullItem}
        />
      );
    } else {
      return null;
    }
  }

  renderItem(model) {
    if (model.type === SUB_HEADER) {
      // TODO: setup more generic header with i18n message support for PERSONNEL type
      return !this.props.useTypeHeaders ? null : (
        <DateHeader
          key={getId(model)}
          date={model.name}
        />
      );
    } else {
      const id = getId(model);
      return (
        <PeopleItem
          key={id}
          isSimple={this.props.useSimple}
          className={getItemClass(model)}
          isSelected={this.props.useSelection ? getId(this.props.selected) === id : false}
          model={model}
          onClick={this.props.onClickItem}
          onContextMenu={this.props.onItemContextMenu}
        />
      );
    }
  }
}



// WEBPACK FOOTER //
// ./src/js/personnel/components/PeopleSelectorList/PeopleSelectorListComponent.js